export default __webpack_public_path__ + "static/media/1-3-x@3x.e56086df.png";